import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export class FormRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getSpecsForm() {
    throw new Error('[FormRepository#getSpecsForm] must be implemented')
  }
}
